import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { push } from 'react-router-redux'
import axios from 'axios'

// Styles
import styles from './styles'

// Material UI
import { withStyles } from 'material-ui/styles'
import Button from 'material-ui/Button'
import Send from 'material-ui-icons/KeyboardArrowRight'

import { overlapOpen } from './actions'

class FullProfileButton extends Component {
  onSelect(access_id, myComponent) {
    /*
    axios({
      method: 'get',
      url: 'https://api.dsnapis.com/customer/'+this.props.customer_number+'/pw/teSt1/profileid/'+access_id+'/colorid/4/db/2',
      data: {
        firstName: 'James',
        lastName: 'Zammit'
      }
    }).then(function (response) {

    });*/

    //myComponent.props.changeRoute("/console/user/"+access_id);
    myComponent.props.overlapOpen(true, access_id)
  }

  render() {
    const { classes, theme, location, data } = this.props
    console.log('data button is' + data['access id'])

    var access_id = data['access id']
    let myComponent = this

    return (
      <div className={classes.root}>
        <Button
          className={classes.topClick}
          onClick={() => this.onSelect(access_id, myComponent)}
          raised
          color="primary"
        >
          <div className={classes.text}>View Candidate Folder</div>
          <Send className={classes.rightIcon} />
        </Button>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    customer_number: state.customer.number,
    project_id: state.prefix.project_id
  }
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      overlapOpen: overlapOpen
    },
    dispatch
  )
}

export default withRouter(
  withStyles(styles, { withTheme: true })(
    connect(mapStateToProps, matchDispatchToProps)(FullProfileButton)
  )
)



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/Item/components/FullProfileButton/index.js